export const FUNNEL_ADDRESS_STEP = 'address';
export const FUNNEL_PAYMENT_SELECTION_STEP = 'payment_selection';
export const FUNNEL_PAYMENT_PROCESSING_STEP = 'payment_processing';

export const EBON_BILLING_FORM_NAME = 'ebonbilling-form';



// WEBPACK FOOTER //
// ./src/constants/funnel.js